import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MasterService } from "@frontend/app/serivces/master.service";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { SanitizerPipe } from "../../../pipes/sanitizer.pipe";

@Component({
  selector: "app-finance-details",
  imports: [CommonModule, SanitizerPipe],
  templateUrl: "./finance-details.component.html",
  styleUrl: "./finance-details.component.scss",
})
export class FinanceDetailsComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private masterService = inject(MasterService);
  private router = inject(Router);

  ngOnInit(): void {
    // this.calculateTotalPayments();
    this.activatedRoute.queryParams.subscribe(params => {
      const studentID = params["StudentID"];
      if (studentID) {
        this.studentID = studentID;
        this.getFinanceDataByID();
      }
    });
  }
  //#region variables
  studentID = 0;
  totalPayments = 0;
  studentData: any;
  readonly SVG_ICONS = SVG_ICONS;
  //#endregion

  // getFinanceDataByID() {
  //   this.masterService.getFinanceMasterByID(this.studentID).subscribe((res: any) => {

  //     // ---- Student Basic Data ----
  //     this.studentData = {
  //       StudentID: res.Student.StudentID,
  //       FirstName: res.Student.FirstName,
  //       MiddleName: res.Student.MiddleName,
  //       LastName: res.Student.LastName,
  //       MobileNo: res.Student.MobileNo,
  //       center: res.Student.center
  //     };

  //     // ---- Filter only selected subscription ----
  //     if (this.subscriptionID) {
  //       this.studentData.packageSubscriptions =
  //         res.Student.packageSubscriptions.filter((x: any) => x.SubscriptionID == this.subscriptionID);
  //     }

  //     // ---- Filter only selected class ----
  //     if (this.classID) {
  //       this.studentData.classEnrollments =
  //         res.Student.classEnrollments.filter((x: any) => x.ClassID == this.classID);
  //     }

  //     // ---- Filter Payment Ledger by selected Subscription ----
  //     this.studentData.PaymentLedger = res.PaymentLedger.filter(
  //       (x: any) => x.PID == this.subscriptionID
  //     );

  //     // ---- Calculate Total Payments only for this Subscription ----
  //     this.totalPayments = this.studentData.PaymentLedger
  //       .filter((x: any) => x.Credit > 0)
  //       .reduce((sum: number, item: any) => sum + item.Credit, 0);

  //   });
  // }

  getFinanceDataByID() {
    this.masterService.getFinanceMasterByID(this.studentID).subscribe((res: any) => {
      // ---- Set Student data ----
      this.studentData = {
        ...res.Student,
        PaymentLedger: res.PaymentLedger || [],
      };

      // ---- Calculate Total Payments (sum of all credits) ----
      this.totalPayments = res.PaymentLedger.filter((x: any) => x.Credit > 0).reduce((sum: number, item: any) => sum + item.Credit, 0);

    });
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  }

  getInitial(name: string): string {
    return name.charAt(0).toUpperCase();
  }

  onBack() {
    this.router.navigate(["student/student-details"], { queryParams: { StudentID: this.studentID } });
  }
}
